import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {UpmPlantsHierarchyResponse} from '../types'

export const UpmPlantsHierarchyQueryKey = 'upmPlantsHierarchy'

export const useUpmPlantsHierarchy = (
  options?: Omit<
    UseQueryOptions<UpmPlantsHierarchyResponse, AxiosError, UpmPlantsHierarchyResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<UpmPlantsHierarchyResponse, AxiosError, UpmPlantsHierarchyResponse>({
    queryKey: [UpmPlantsHierarchyQueryKey],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<UpmPlantsHierarchyResponse>(
        '/upm/plants/hierarchy',
        {
          signal
        }
      )
      return response.data
    },
    ...options
  })
}
